import { Injectable } from '@angular/core';
import { JssContextService } from '../../jss-context.service';

@Injectable({
  providedIn: 'root'
})
export class ConfigurationSettingsContextService {
  constructor(jssContextService: JssContextService) {
    jssContextService.state.subscribe((result) => {
      if (
        result.sitecore?.context &&
        result.sitecore?.context.configurationSettings
      ) {
        this.configurationSettingsContext =
          result.sitecore?.context.configurationSettings;
      }
    });
  }

  private configurationSettingsContext: any;

  public get configurationSettings() {
    return this.configurationSettingsContext;
  }

  public getConfigurationSettingsValidationAttributeValue(
    validationAttributeName: string
  ) {
    if (
      validationAttributeName &&
      this.configurationSettingsContext &&
      this.configurationSettingsContext.validationAttributes &&
      this.configurationSettingsContext.validationAttributes[
        validationAttributeName
      ]
    ) {
      return this.configurationSettingsContext.validationAttributes[
        validationAttributeName
      ];
    }

    return null;
  }
}
